export default "__VITE_ASSET__adWGhv3K__";